import { callEndpoint } from './apiUtils';

export const activeParticipantsApi = (jwt: string) =>
  callEndpoint<ActiveParticipantsResponse>('active-participants', jwt, 'GET');
